import { Component, inject, DestroyRef } from '@angular/core';
import { Router, NavigationStart, RouterLink } from '@angular/router';
import {filter} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {SharedMaterialUIModule} from "@shared/modules/shared-material-ui.module";
import {PermissionService} from "../../services/permission.service";
import Keycloak from "keycloak-js";
import {ApiErrorService} from "../../services/api-error.service";
import {Permission} from "@shared/enums/permission.enum";
import {getApiBaseUrl} from "../../services/api-base-url";
import {CHECK_PERMISSIONS} from "@shared/modules/permissions.module";
import { HorizontalBarMenu } from "../menu/navigation/horizontal-bar-menu/horizontal-bar-menu";

@Component({
  selector: 'app-header',
  imports: [...SharedMaterialUIModule, HorizontalBarMenu],
  templateUrl: './header.html',
  styles: ``,
})
export class Header {
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private readonly keycloak = inject(Keycloak);
  private readonly permissionService = inject(PermissionService);
  private readonly apiErrorService = inject(ApiErrorService);
  protected readonly hangfireDashboardUrl = `${getApiBaseUrl()}hangfire`;
  protected readonly verifyPermissions = CHECK_PERMISSIONS();

  constructor() {
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationStart),
      takeUntilDestroyed(this.destroyRef),
    )
    .subscribe(() => this.apiErrorService.clearError());
  }

  protected async login(): Promise<void> {
    await this.keycloak.login();
  }

  protected async logout(): Promise<void> {
    await this.keycloak.logout({ redirectUri: window.location.origin });
  }

  protected goToPage(route: string): void {
    void this.router.navigate([route]);
  }

  protected goToHangfire(): void {
    window.open(this.hangfireDashboardUrl, '_blank', 'noopener,noreferrer');
  }
}
